import { Action } from '@ngrx/store';
import { ExtractListModel } from "../../models/ExtractListModel";

export const GET_EXTRACT_LIST_SUCCESS_ACTION = '[Submission] Get Extract List Success Action';

export class GetExtractListSuccessAction implements Action {
  readonly type: string;

  constructor(public payload: { items: ExtractListModel[] }) {
    this.type = GET_EXTRACT_LIST_SUCCESS_ACTION;
  }
}



// WEBPACK FOOTER //
// ./src/app/extracts/store/actions/GetExtractListSuccessAction.ts